export default {
  title: 'Ações Rápidas',
  send_push_notification: {
    label: 'Enviar Notificação Push',
    description: 'Criar uma nova campanha',
  },
  email_campaign: {
    label: 'Campanha de E-mail',
    description: 'Enviar para subscritores',
  },
  view_analytics: {
    label: 'Ver Análises',
    description: 'Desempenho da campanha',
  },
};
